/**
 * Created by Timur on 21.08.2026
 */

const Merge2MissionLogic = function (mission, isNewMission) {
    cleverapps.EventEmitter.call(this);

    this.mission = mission;

    const details = mission.details || {};

    this.library = new Merge2MissionUnitsLibrary(details.library);
    this.vipPass = new Merge2MissionVipPass(this.library, details.vipPass || {});
    this.bubblesStack = new Merge2MissionBubblesStack(details.bubblesStack);
    this.offerStarted = details.offerStarted;
    this.period = isNewMission ? Merge2MissionHelper.getPeriod() : details.period || Merge2MissionLogic.LEGACY_PERIOD;

    mission.eventFinishTime = Merge2MissionHelper.getEvent(this.period).finish.getTime();

    this.field = new Merge2MissionField();
    this.field.load(details.field);
    this.field.iterateVisible((unit) => this.library.restore(unit));
    this.field.on("unitAdded", this.onUnitAdded.bind(this));
    this.field.on("unitReleased", (unit, released) => this.onUnitAdded(released));

    if (isNewMission) {
        this.bubblesStack.fill();
        this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, {
            value: this.bubblesStack.size(),
            itemId: "start"
        });

        this.mission.result = this.library.count();
    }
};

Merge2MissionLogic.prototype = Object.create(cleverapps.EventEmitter.prototype);
Merge2MissionLogic.prototype.constructor = Merge2MissionLogic;

Merge2MissionLogic.prototype.markOfferStarted = function () {
    this.offerStarted = true;
    this.mission.onChanged();
};

Merge2MissionLogic.prototype.update = function () {
    this.mission.update(this.library.count() - this.mission.result);

    this.trigger("onStateChanged");
};

Merge2MissionLogic.prototype.getInfo = function () {
    return {
        field: this.field.getInfo(),
        bubblesStack: this.bubblesStack.getInfo(),
        library: this.library.getInfo(),
        vipPass: this.vipPass.getInfo(),
        offerStarted: this.offerStarted,
        period: this.period
    };
};

Merge2MissionLogic.prototype.save = function (details) {
    const info = this.getInfo();

    details.field = info.field;
    details.bubblesStack = info.bubblesStack;
    details.library = info.library;
    details.vipPass = info.vipPass;
    details.offerStarted = info.offerStarted;
    details.period = info.period;
};

Merge2MissionLogic.prototype.canRemoveSilently = function () {
    return !Merge2MissionHelper.hasBundles(this.period);
};

Merge2MissionLogic.prototype.isRunning = function () {
    return this.mission.isRunning();
};

Merge2MissionLogic.LEGACY_PERIOD = "october";

Merge2MissionLogic.getOrdersConfig = function () {
    return bundles.merge2mission_config.jsons.merge2mission_orders_json.getJson();
};

Merge2MissionLogic.prototype.getOrderRewards = function (recipe) {
    const tiers = Merge2MissionLogic.getOrdersConfig().tiers;
    const stars = recipe.calcOrderStars();

    const tier = tiers.find((entry) => stars <= entry.stars) || tiers[tiers.length - 1];
    const items = recipe.ingredients.length > 1 ? tier.multiple : tier.single;

    return {
        merge2MissionItems: items
    };
};

Merge2MissionLogic.prototype.isAttentionRequired = function () {
    return this.library.hasUnclaimedRewards()
        || this.vipPass.hasClaimableStages();
};

Merge2MissionLogic.prototype.onUnitAdded = function (unit) {
    if (this.library.discover(unit)) {
        this.trigger("unitDiscovered", unit);
        this.shiftFieldFor(unit);
    }
};

Merge2MissionLogic.prototype.shiftFieldFor = function (unit) {
    const offset = this.field.getOffsetFor(unit);
    if (offset !== undefined) {
        this.shiftField(offset);
    }
};

Merge2MissionLogic.prototype.shiftField = function (offset) {
    const items = this.field.setVisibleOffset(offset);
    items.forEach((item) => this.bubblesStack.push(item.code, item.stage, item.data));

    if (items.length > 0) {
        this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, {
            value: items.length,
            itemId: "shift"
        });
    }
};

Merge2MissionLogic.prototype.pushDrops = function (drop, itemId) {
    drop.forEach((entry) => {
        for (let i = 0; i < entry.amount; i++) {
            this.bubblesStack.push(entry.code, entry.stage);
        }
    });

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, {
        value: drop.reduce((sum, entry) => sum + entry.amount, 0),
        itemId
    });
};

Merge2MissionLogic.prototype.scatterDrops = function (drop, origin) {
    const overflow = [];
    let index = 0;

    drop.forEach((entry) => {
        let missed = 0;

        for (let i = 0; i < entry.amount; i++) {
            if (this.field.spawn(entry.code, entry.stage, undefined, { x: origin.x, y: origin.y, index })) {
                index++;
            } else {
                missed++;
            }
        }

        if (missed > 0) {
            overflow.push({ code: entry.code, stage: entry.stage, amount: missed });
        }
    });

    return overflow.length > 0 ? { merge2MissionItems: overflow } : undefined;
};

Merge2MissionLogic.prototype.moveUnit = function (fromX, fromY, toX, toY) {
    const result = this.field.tryMove(fromX, fromY, toX, toY);
    if (result.move === Merge2MissionField.MOVE.REJECTED) {
        return result;
    }

    if (result.move === Merge2MissionField.MOVE.MERGED) {
        result.reward = this.onMerged(result.unit, { x: toX, y: toY });
    } else if (result.move === Merge2MissionField.MOVE.FED) {
        this.onFed();
    } else {
        this.update();
    }

    return result;
};

Merge2MissionLogic.prototype.onMerged = function (unit, origin) {
    cleverapps.playSession.logAvg(cleverapps.EVENTS.MERGE2_MISSION_MERGES, { value: 1 });

    const stageConfig = unit.getStageConfig();
    const reward = stageConfig.drop && this.scatterDrops(stageConfig.drop, origin);

    this.update();

    if (stageConfig.type === Merge2MissionFamilies.TYPE.GOAL) {
        this.trigger("mainGoalCompleted", unit);
    }

    return reward;
};

Merge2MissionLogic.prototype.onFed = function () {
    this.library.registerActivation();

    this.update();
};

Merge2MissionLogic.prototype.spawnFromStack = function () {
    const item = this.bubblesStack.top();
    if (!item) {
        return undefined;
    }

    const origin = { ...this.field.getQueueOrigin(), fromStack: true };

    const unit = this.field.spawn(item.code, item.stage, item.data, origin);
    if (!unit) {
        return undefined;
    }

    this.bubblesStack.pop();
    if (this.bubblesStack.isEmpty()) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.MERGE2_MISSION_STACK_EMPTY);
    }

    this.update();

    return unit;
};

Merge2MissionLogic.prototype.mine = function (unit) {
    const origin = { x: unit.x, y: unit.y };

    const result = this.field.mine(unit);
    if (!result) {
        return undefined;
    }

    const reward = result.drop ? this.scatterDrops(result.drop, origin) : result.reward;

    this.update();

    return { reward };
};

Merge2MissionLogic.prototype.collectReward = function (unit) {
    const reward = this.field.collectReward(unit);
    if (!reward) {
        return undefined;
    }

    this.update();

    return reward;
};

Merge2MissionLogic.prototype.transform = function (unit) {
    const result = this.field.transform(unit);
    if (!result) {
        return undefined;
    }

    this.update();

    return result;
};

Merge2MissionLogic.prototype.collectUnitReward = function (code, stage) {
    const reward = this.library.collectUnitReward(code, stage);
    if (!reward) {
        return undefined;
    }

    this.update();

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
        reward,
        itemId: "unit"
    });

    return reward;
};

Merge2MissionLogic.prototype.collectGroupReward = function (group) {
    const reward = this.library.collectGroupReward(group);
    if (!reward) {
        return undefined;
    }

    this.update();

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
        reward,
        itemId: `group_${group}`
    });

    return reward;
};

Merge2MissionLogic.prototype.collectLibraryReward = function () {
    const reward = this.library.collectLibraryReward();
    if (!reward) {
        return undefined;
    }

    this.update();

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
        reward,
        itemId: "library"
    });

    return reward;
};

Merge2MissionLogic.prototype.claimVipStage = function (stage, vip) {
    const reward = this.vipPass.claim(stage, vip);
    if (!reward) {
        return undefined;
    }

    this.update();

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
        reward,
        itemId: `vip_${vip ? "paid" : "free"}_${stage}`
    });

    return reward;
};

Merge2MissionLogic.prototype.unlockVipPass = function () {
    if (this.vipPass.isUnlocked()) {
        return false;
    }

    this.vipPass.unlock();
    this.update();

    return true;
};

Merge2MissionLogic.prototype.beforeRemove = function (f) {
    let rewards = this.vipPass.getAllUnclaimedRewards();
    rewards = RewardsList.sumRewards(rewards, this.library.getAllUnclaimedRewards());

    if (RewardsList.isEmpty(rewards)) {
        f();
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_REWARD_VALUE, {
        reward: rewards,
        itemId: "leftover"
    });

    new RewardWindow(rewards, {
        event: cleverapps.EVENTS.EARN.MERGE2_MISSION,
        toBubbleStack: true
    });
    cleverapps.focusManager.onceNoWindowsListener = f;
};
